import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section id="home" className="relative w-full h-screen min-h-[600px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Artistic%20editorial%20flat%20lay%20of%20premium%20sneakers%20and%20streetwear%20fashion%20on%20rich%20dark%20olive%20green%20backdrop%2C%20modern%20luxury%20fashion%20photography%2C%20dramatic%20side%20lighting%2C%20clean%20minimalist%20composition%2C%20high%20contrast%20moody%20atmosphere%2C%20elegant%20shadows%20and%20highlights%2C%20sophisticated%20product%20styling%2C%20warm%20metallic%20accents&width=1920&height=1080&seq=hero-bg-oopbuy-v3&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55" />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-[700px]">
          <h1 className="text-white mb-4 md:mb-6 animate-fade-in-up">
            <span className="block text-4xl md:text-6xl lg:text-7xl font-heading font-bold leading-tight">
              {t("hero_line1")}
            </span>
            <span className="block text-3xl md:text-5xl lg:text-6xl font-heading font-semibold leading-tight mt-2">
              {t("hero_line2")}
            </span>
            <span className="block text-3xl md:text-5xl lg:text-6xl font-heading font-semibold leading-tight mt-2 text-primary-300">
              {t("hero_line3")}
            </span>
          </h1>

          <div className="mt-8 md:mt-10 animate-fade-in-up animation-delay-200 flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-white font-semibold rounded-full text-sm md:text-base hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t("hero_cta")}
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <button
              onClick={() => {
                const el = document.getElementById("guides");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-white/30 text-white font-medium rounded-full text-sm md:text-base hover:bg-white/15 transition-colors cursor-pointer whitespace-nowrap"
            >
              Kompletten Guide lesen
              <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center"></i>
            </button>
          </div>

          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2 animate-fade-in-up animation-delay-400">
            {[
              "Deutsche Erklärung",
              "Übersichtliche Kategorien",
              "Schritt-für-Schritt Anleitung",
              "Sicherheitsinformationen",
              "Regelmäßig aktualisiert",
            ].map((item) => (
              <span key={item} className="flex items-center gap-1.5 text-white/80 text-xs md:text-sm">
                <i className="ri-check-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full pb-6 md:pb-10 z-10">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <p className="text-white/70 text-[11px] md:text-xs font-medium tracking-[0.3em] uppercase animate-fade-in animation-delay-600">
            {t("hero_tagline")}
          </p>
        </div>
      </div>
    </section>
  );
}